import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['source', 'button', 'originalText', 'copyIcon', 'checkIcon', 'buttonText']
  static values = {
    originalText: String
  }

  async copy() {
    const text = this.sourceTarget.textContent || this.sourceTarget.value

    try {
      await navigator.clipboard.writeText(text)
      this.showSuccess()
    } catch (err) {
      this.fallbackCopy(text)
    }
  }

  fallbackCopy(text) {
    const textArea = document.createElement('textarea')
    textArea.value = text
    textArea.style.position = 'fixed'
    textArea.style.left = '-999999px'
    textArea.style.top = '-999999px'
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
      document.execCommand('copy')
      this.showSuccess()
    } catch (err) {
      console.error('Fallback copy failed:', err)
      this.showError()
    } finally {
      document.body.removeChild(textArea)
    }
  }

  showSuccess() {
    this.buttonTextTarget.textContent = 'Copiado!'
    this.buttonTarget.classList.remove('bg-blue-600', 'hover:bg-blue-700')
    this.buttonTarget.classList.add('bg-green-600', 'hover:bg-green-700')

    if (this.hasCopyIconTarget) {
      this.copyIconTarget.classList.add('hidden')
    }
    if (this.hasCheckIconTarget) {
      this.checkIconTarget.classList.remove('hidden')
    }

    setTimeout(() => {
      this.resetButton()
    }, 2000)
  }

  showError() {
    this.resetButton()
  }

  resetButton() {
    this.buttonTextTarget.textContent = this.originalTextValue
    this.buttonTarget.classList.remove('bg-green-600', 'hover:bg-green-700', 'bg-red-600', 'hover:bg-red-700')
    this.buttonTarget.classList.add('bg-blue-600', 'hover:bg-blue-700')

    if (this.hasCopyIconTarget) {
      this.copyIconTarget.classList.remove('hidden')
    }
    if (this.hasCheckIconTarget) {
      this.checkIconTarget.classList.add('hidden')
    }
  }
}
